//
// Copyright 2024 DXOS.org
//

/**
 * Locks the storage to prevent multiple instances of the client from running.
 */
export const STORAGE_LOCK_KEY = 'dxos-client-worker';
